import { ALLOWED_MEDIA } from '@/app/components/media/app-image/responsive-image/constants';

export const APP_VIDEO_DEFAULTS = {
  desktopMedia: ALLOWED_MEDIA.lgUp,
  testId: 'app-video',
  posterSizes: '100vw',
} as const;
